import { render, staticRenderFns } from "./SelectLang.vue?vue&type=template&id=e4fe5586&scoped=true"
import script from "./SelectLang.vue?vue&type=script&lang=js"
export * from "./SelectLang.vue?vue&type=script&lang=js"
import style0 from "./SelectLang.vue?vue&type=style&index=0&id=e4fe5586&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4fe5586",
  null
  
)

export default component.exports